export default "__VITE_ASSET__CqWI_8in__"